import ArticleCardHome from 'Components/article_card_home'
import ButtonMore from '@fdn/button_more'
import ErrorPlaceholder from '@fdn/error_placeholder'
import {handleUrlArticle} from 'Helpers/utils'

const PopularLifestyleArticleMobile = ({
  title,
  dataArticle,
  is_mobile,
  slug_url,
  section_name,
}) => {
  return (
    <div className="people-lifestyle-article section">
      <div className="section-title-wrapper">
        <h3 className="section-title">{title}</h3>
      </div>

      {Array.isArray(dataArticle) ? (
        dataArticle.length ? (
          <>
            <div className="popular-article-wrapper">
              {dataArticle.slice(0, 4).map((item, idx) => (
                <ArticleCardHome
                  key={idx}
                  is_mobile={is_mobile}
                  is_sponsored={false}
                  font_title={`Josefin Sans, sans-serif`}
                  article={Object.assign({
                    category: { name: item.category_slug.replace(/[_]/g, ' ') },
                    date: item.created_at,
                    title: item.title,
                    text: item.excerpt,
                    image: item.image,
                    url: handleUrlArticle(item.url),
                    author: { fullname: item.author.name },
                  })}
                  url_category={`${
                    process.env.NEXT_PUBLIC_ROOT_DOMAIN
                  }/blog/category/${item.category_slug.replace(/[_]/g, '-')}`}
                  url_author={`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/author/${item.author.username}`}
                  type={'type-2'}
                />
              ))}
            </div>
            <div className="btn-more-wrapper">
              <ButtonMore
                text={'SEE ARTICLES IN ' + title.toUpperCase()}
                font_family={`Josefin Sans, sans-serif`}
                font_size={12}
                font_weight={400}
                color={'#000000'}
                link={process.env.NEXT_PUBLIC_ROOT_DOMAIN + slug_url}
                element_id={'btn-more-article-' + section_name}
              />
            </div>
          </>
        ) : (
          <div className="popular-article-wrapper">
            <ErrorPlaceholder
              is_mobile={is_mobile}
              icon="https://s3-ap-southeast-1.amazonaws.com/assets.femaledaily.com/editorial/no-data-icon.svg"
              icon_alt="no data icon female daily"
              title="Sorry :("
              text="There’s no data to display"
            />
          </div>
        )
      ) : (
        <div className="popular-article-wrapper">
          <ErrorPlaceholder
            is_mobile={is_mobile}
            icon="https://s3-ap-southeast-1.amazonaws.com/assets.femaledaily.com/editorial/something-wrong-icon.svg"
            icon_alt="wrong icon female daily"
            title="Uh Oh!"
            text="Something went wrong"
          />
        </div>
      )}
      <style>
        {`
          .people-lifestyle-article.section {
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          .people-lifestyle-article-wrapper {
            display: grid;
            grid-template-columns: 1fr;
            width: 100%;
            box-sizing: border-box
          }

          .people-lifestyle-article .fdn-article-card-mobile-type-2 {
            margin-bottom: 24px;
          }
          .people-lifestyle-article .btn-more-wrapper {
            display: flex;
            justify-content: center;
            width: 100%;
          }

          .people-lifestyle-article .btn-see-more p {
            letter-spacing: 0.1em;
          }

          .people-lifestyle-article .section-title {
            font-family: Josefin Sans, sans-serif;
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            line-height: 20px;
            letter-spacing: 0.1em;
            color: #000000;
          }

          .people-lifestyle-article .section-title:not(.bordered)::before, .section-title:not(.bordered)::after {
            top: -5px;
          }

          .fdn-article-card-mobile-type-2 div.article-info a.article-title {
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 3; 
            -webkit-box-orient: vertical;
          }
          
        `}
      </style>
    </div>
  )
}

export default PopularLifestyleArticleMobile
